import { render } from "./Order_info.vue?vue&type=template&id=55166ca3"
import script from "./Order_info.vue?vue&type=script&lang=js"
export * from "./Order_info.vue?vue&type=script&lang=js"

import "./Order_info.vue?vue&type=style&index=0&id=55166ca3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__